import { IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

const AppMenuBar = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (callback) => {
    setAnchorEl(null);
    callback?.();
  };

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        {props.children}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose?.bind(this, undefined)}
        className="z-[1000000]"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {props?.options?.map((item, index) => (
          <MenuItem
            className="flex gap-2 items-center"
            key={`menu-${index}`}
            onClick={handleClose?.bind(this, item?.onPress)}
          >
            {item?.icon}
            <h2
              style={{ color: item?.color ?? "#000" }}
              className="font-['CG-Medium'] text-base pt-[1px]"
            >
              {item.title}
            </h2>
          </MenuItem>
        ))}

        {/* <MenuItem onClick={handleClose}>My account</MenuItem>
                <MenuItem onClick={handleClose}>Logout</MenuItem> */}
      </Menu>
    </>
  );
};

export default AppMenuBar;
